import styled from 'styled-components';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;

  td a {
    font-weight: bold;
    text-decoration: none;

    &:focus,
    &:hover {
      text-decoration: underline;
    }
  }

  th.home-offers-list-th-status {
    width: 10%;
  }

  th.home-offers-list-th-name {
  }

  th.home-offers-list-th-created-at {
    width: 15%;
  }

  th.home-offers-list-th-offer {
  }

  th.home-offers-list-th-actions {
    width: 10%;
  }
`;

export const HelpTable = styled.table`
  border-top: 1px solid #e0e0e0;
  margin-top: 3rem;

  tr td {
    border-bottom: 1px solid #e0e0e0;
    padding: 1rem;
  }
`;

export const NoContent = styled.p`
  text-align: center;
  font-size: 2rem;
  padding: 4rem 0;
  background: #eee;
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  margin-top: 1.5rem;
`;

export const PaginationButton = styled.button<{ $active?: boolean }>`
  background-color: ${({ $active }) => ($active ? '#2b6cb0' : '#fff')};
  color: ${({ $active }) => ($active ? '#fff' : '#2d3748')};
  border: 1px solid #cbd5e0;
  border-radius: 0.25rem;
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  &:hover:not(:disabled) {
    background-color: ${({ $active }) => ($active ? '#2b6cb0' : '#edf2f7')};
    border-color: #a0aec0;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
    background-color: #f7fafc;
  }
`;
